module.exports = __webpack_public_path__ + "img/intro_1.82ed47a7.png";